import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { ChatContext } from '../../../../coaching-base/chat-context.model';
import { ChatService } from '../../../../coaching-base/chat.service';
import { CommitmentChat } from '../../../../coaching-base/general';
import { Dependencies } from '../../../../store';
import { pluck } from '../../../../store.decorator';
import { PayloadAction } from '../../../../store.model';
import { SocketService } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<any> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCD__RELOAD),
        mergeMap((act: PayloadAction<ActionType, Reload>) => {
            const rootState = pluck<TeamschatDialogState>(
                state.value,
                act.storePath,
            );
            const service = deps.injector.get<ChatService>(ChatService);
            const socketService =
                deps.injector.get<SocketService>(SocketService);

            let chat: CommitmentChat;
            if (act.payload.chat != null) {
                let ctx: ChatContext | null;
                try {
                    ctx = JSON.parse(act.payload.chat?.context);
                } catch {}

                chat = {
                    chatId: act.payload.chat.chatId,
                    commitmentId: ctx?.commitmentId,
                };
            }

            if (chat?.chatId == null || act.payload.errorCode != null) {
                return of(
                    reloadResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    ),
                );
            }

            const obs =
                rootState.commitmentChat?.chatId === chat.chatId
                    ? of(null)
                    : service.create(chat);

            return obs.pipe(
                tap(() => {
                    void socketService.listChatMessages(act.payload.chat);
                }),
                map(() => {
                    return reloadResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
